import { render, staticRenderFns } from "./CreateInfo.vue?vue&type=template&id=1f22b93b&scoped=true"
import script from "./CreateInfo.vue?vue&type=script&lang=js"
export * from "./CreateInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateInfo.vue?vue&type=style&index=0&id=1f22b93b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22b93b",
  null
  
)

export default component.exports